<template>
    <div class="row-container">
        <LogoComponent @click="$emit('logoClick')" />
        <UserDropdownComponent
            v-if="hasDropdown"
            :username="username"
            @logout="$emit('logout')"
            @historyClick="$emit('historyClick')"
            @spotClick="$emit('spotClick')"
            @accountClick="$emit('accountClick')"
        />
    </div>
</template>

<script>
import UserDropdownComponent from '@/components/UserDropdownComponent';
import LogoComponent from '@/components/LogoComponent';

export default {
    name: 'NavbarComponent',
    props: {
        hasDropdown: Boolean,
        username: String
    },
    components: {
        UserDropdownComponent,
        LogoComponent
    }
};
</script>

<style lang="scss" scoped>
    .row-container {
        display: flex;
        justify-content: space-between;
        margin: 10px;
    }

    @media screen and (max-width: 600px) {
        .row-container {
            flex-direction: column;
        }
    }
</style>